import Layout from "@/layouts/Layout.vue";
import RFIDDevice from "@/views/rfid/RFIDDevice.vue"
import { UserPermissions } from "@/utils";

let rfidRoute = {
  path: "/rfid",
  component: Layout,
  name: "RFID Устройство ",
  redirect: "/rfid",
  hidden: true,
  meta: {
    actions: [UserPermissions.USER, UserPermissions.ADMIN],
  },
  children: [
    {
      path: "/rfid",
      name: "RFID устройство",
      component: RFIDDevice,
      meta: {
        title: "RFID устройство",
        actions: [UserPermissions.USER, UserPermissions.ADMIN],
        icon: "mdi-cellphone-nfc",
      },
      hidden: false
    }
  ]
}

export default rfidRoute;